import { get, post } from '@/utils/request'

// 首页相关接口
export const homeApi = {
  // 获取轮播信息
  getBannerList: () => get(`/index.php/Banner/getBannerList`),
  // 获取新功能推广
  getFeatureDetailList: () => get(`/index.php/FeatureDetail/getFeatureDetailList`),
// 获取应用场景标题和按钮
getAppScenarionList: () => get('/index.php/AppScenarion/getAppScenarionList'),
// 应用场景 展示位置
  getAppScenarionConfig: () => get('/index.php/AppScenarion/getAppScenarionConfig'),
// 战略伙伴
  getPartner: () => get('/index.php/Cooperation/getPartner'),
// 合作酒吧
  getBar: () => get('/index.php/Cooperation/getBar'),
// 瓷片区 标题按钮设置
  getConfigSet: () => get('/index.php/FeatureConfig/getConfigSet'),
// 功能业务详情区 瓷片列表
  getChipList: () => get('/index.php/FeatureChip/getChipList'),
// 获取动态咨询
  getOffcial: () => get('/index.php/Official/getOffcial'),
  // 获取导航内容
  getNav: () => get('/index.php/Navigation/getNav'),
  // 内容补充区
  getReplenish: () => get('/index.php/Replenish/getReplenish'),
  // 获取消息列表
  getNewsList: (page) => get(`/index.php/Official/getOfficaPage?page=${page}`),
  // 获取某一个消息详情
  getNewsListInfo: (id) => get(`/index.php/Official/getOffcialById?id=${id}`),
  // 获取联系我们
  getContact: (params) => post('/index.php/Index/ContactUs', params),

}